import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=64778763&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64778763",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-gov-report/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64778763')) {
      api.createRecord('64778763', component.options)
    } else {
      api.reload('64778763', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=64778763&scoped=true&", function () {
      api.rerender('64778763', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout.vue"
export default component.exports